import React from 'react';
import { useDrop } from 'react-dnd';
import { Content } from './styles';
import { COMPLEX_PAGE_OPTIONS } from './translationValues';

const VerticalCell = ({ uuid, editable, type, onDrop, className, getElementStyles, currentBlockEditing, ...props }) => {

    const [isOver, drop] = useDrop({
      canDrop: (item) => editable && props.enableDropOver,
      accept: type,
      drop: (item, monitor) => {
        if (item.element?.elementDetails?.uuid === uuid) {
          return { drop: true };
        }
        return onDrop(item, uuid, 'over');
      },
      collect: monitor => !!monitor.isOver() && monitor.getItem().element?.elementDetails?.uuid !== uuid,
    });

    const [isOverTop, topDrop] = useDrop({
      canDrop: (item) => editable,
      accept: type,
      drop: (item, monitor) => {
        if (item.element?.elementDetails?.uuid === uuid) {
          return { drop: true };
        }
        return onDrop(item, uuid, 'top');
      },
      collect: monitor => !!monitor.isOver() && monitor.getItem().element?.elementDetails?.uuid !== uuid,
    });

    const [isOverBottom, bottomDrop] = useDrop({
      canDrop: (item) => editable,
      accept: type,
      drop: (item, monitor) => {
        if (item.element?.elementDetails?.uuid === uuid) {
          return { drop: true };
        }
        return onDrop(item, uuid, 'bottom');
      },
      collect: monitor => !!monitor.isOver() && monitor.getItem().element?.elementDetails?.uuid !== uuid,
    });

    return (
      <Content
        data-dropContent={props.t(
          COMPLEX_PAGE_OPTIONS.DROP_CONTENT_HERE_LABEL.key,
          COMPLEX_PAGE_OPTIONS.DROP_CONTENT_HERE_LABEL.value,
        )}
        className={`${className} ${editable && (isOverTop || isOverBottom) ? 'isOver' : ''}`}
        ref={drop}
        id={uuid}
        // onMouseMove={e => editable && !currentBlockEditing && getElementStyles && getElementStyles(e, uuid)}
      >
        {props.children}
        {editable && isOver && (
          <>
              <div ref={topDrop} className={`topDrop ${isOverTop ? 'visible' : ''}`} />
              <div ref={bottomDrop} className={`bottomDrop ${isOverBottom ? 'visible' : ''}`} />
          </>
        )}
      </Content>
    );
}

/*const VerticalLayout = ({ uuid, editable, type, createElement, renderer, parentForceUpdate, callerLayoutType = ELEMENT_TYPES.CELL, customRef = null }) => {
  const { getLayoutById, updateLayout, createLayout } = useContext(LayoutContext);
  const [ rows, setRows ] = useState(uuid ? (getLayoutById(uuid)?.contents || []) : []);
  const [ forceUpdate, setForceUpdate] = useState(false);
  // TODO : Continue from horizontal rendering optimisation

  *//*useEffect(() => {
    console.log("change in props :: editable ", editable);
  }, [editable]);

  useEffect(() => {
    console.log("change in props :: type ", type);
  }, [type]);*//*

  *//*useEffect(() => {
    console.log("change in props :: renderer ", renderer);
  }, [renderer]);*//*

  useEffect(() => {
    if (callerLayoutType === ELEMENT_TYPES.PARENT) {
      createLayout(ELEMENT_TYPES.PARENT, undefined, { uuid });
    }
  }, []);

  useEffect(() => {
    const element = getLayoutById(uuid);
    if (element?.contents === undefined) return;
    const rowIds = rows.map(row => row.uuid);
    const contentIds = element?.contents?.map(row => row.uuid);
    console.log("difference in rows :: ", uuid, rowIds.length !== contentIds.length || JSON.stringify(rowIds) !== JSON.stringify(contentIds), forceUpdate);
    if (rowIds.length !== contentIds.length || JSON.stringify(rowIds) !== JSON.stringify(contentIds)) {
      setRows(element.contents);
    }
    if (forceUpdate) {
      setForceUpdate(false);
    }
  }, [uuid, getLayoutById(uuid), forceUpdate]);

  const onDrop = useCallback((dragItem, dropItem, dropType = 'over') => {
    if (dragItem?.uuid === undefined) {
        setRows(rows => {
          let newRows = [...rows];
          const currentIndex = rows.findIndex(row => row.uuid === dropItem);
          const newElement = createElement(dragItem.id);
          const newRow = createLayout(ELEMENT_TYPES.ROW, callerLayoutType, newElement);
          switch (dropType) {
            case 'over':
              newRows = [...rows, newRow];
              break;
            case 'top':
              newRows.splice(currentIndex || 0, 0, newRow);
              break;
            case 'bottom':
              newRows.splice((currentIndex || 0) + 1, 0, newRow);
              break;
            default:
              newRows = rows;
              break;
          }
          updateLayout(uuid, { contents: newRows }, 'update');
          return newRows;
        });
    } else {
      // console.log("Drop in ", uuid, dropType, dropItem);
      updateLayout(uuid, { uuid: dragItem.uuid, dropType, dropItem }, 'move');
      setForceUpdate(true);
      *//*setRows(rows => {
          let newRows = [...rows];
          const movedItemIndex = rows.findIndex(row => row.uuid === dragItem.uuid);
          const movedItem = rows[movedItemIndex];
          newRows.splice(movedItemIndex, 1);
          const currentIndex = newRows.findIndex(row => row.uuid === dropItem);
          switch (dropType) {
            case 'top':
              newRows.splice(currentIndex, 0, movedItem);
              break;
            case 'bottom':
              newRows.splice(currentIndex + 1, 0, movedItem);
              break;
            default:
              newRows = rows;
              break;
          }
          updateLayout(uuid, { contents: newRows }, 'update');
          return rows;
      });*//*
    }
    return {uuid};
  }, [updateLayout, uuid]);

  const [{ isOver: isOver }, drop] = useDrop({
    canDrop: () => editable,
    accept: type,
    drop: (item, monitor) => {
      if (!monitor.didDrop()) {
        return onDrop(item, undefined, 'over');
      }
    },
    collect: monitor => ({
      isOver: !!monitor.isOver({ shallow: true })
    }),
  });

  const forceUpdateLayout = useCallback(() => {
    console.log("forceUpdateLayout cell called : ", uuid);
    setForceUpdate(true);
    if (parentForceUpdate) parentForceUpdate(true);
  }, [parentForceUpdate]);

  *//*useEffect(() => {
    console.log("change in state :: isOver ", isOver);
  }, [isOver]);

  useEffect(() => {
    console.log("change in props :: drop ", drop);
  }, [drop]);*//*

  *//*useEffect(() => {
    console.log("change in props :: rows ", uuid, rows);
  }, [rows]);*//*
  let ref = drop;
  if (customRef) {
    ref = drop(customRef);
  }

  const isEmpty = rows.length === 0;

  console.log("Vertical layout is rendering!! :: ", uuid, rows);
  return (
    <Layout ref={ref} key={uuid}>
      {isEmpty ? (<Content className={`empty ${isOver ? 'droppable' : ''}`}> Drag content from left. </Content>) : rows.map((row, index) => (
        <VerticalCell
          key={row.uuid}
          uuid={row.uuid}
          onDrop={onDrop}
          editable={editable}
          type={type}
          className={callerLayoutType === ELEMENT_TYPES.PARENT && isOver && index === rows.length - 1 ? 'droppable' : ''}
        >
          {renderer(row, forceUpdateLayout)}
        </VerticalCell>
      ))}
      {callerLayoutType === ELEMENT_TYPES.PARENT && (
        <div className="emptySpace" />
      )}
    </Layout>
  )
}*/

export default React.memo(VerticalCell);